import { Component } from '@angular/core';

@Component({
  selector: 'app-auth',
  template: `
    <div class="login-container">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    /* Průchozí kontejner — přihlašovací stránka (app-public-shell) si nese vlastní
       split layout i pozadí přes celý viewport. Žádné centrování ani modrý gradient,
       jinak by se shell vešel jako vycentrovaný box a kolem prosvítala modrá. */
    .login-container {
        min-height: 100vh;
        width: 100%;
    }
  `]
})
export class AuthComponent {}
